import React from 'react';
import styled from 'styled-components';

import PageSingle from 'hive-admin/src/components/PageSingle';
import Admin from 'hive-admin';

import AntdDivider from 'antd/lib/divider';

import logoSrc from '../assets/onboarding-logo.png';
import onboardingSrc from '../assets/onboarding.png';
// import expressSrc from '../assets/onboarding-express.png';

import './PageOnboarding.less';

const Logo = styled.img`
  width: 100px;
`;

const WrapperHeaderRight = styled.div`
  position: relative;
  margin-top: 70px;
  width: 0;

  @media (max-width: 425px) {
    display: none;
  }
`;

const ImageOnboarding = styled.img`
  width: 200px;

  margin-left: -200px;
`;

// const ImageExpress = styled.img`
//   position: absolute;
//   right: -100px;
//   top: -20px;

//   width: 100px;

//   @media (max-width: 1024px) {
//     display: none;
//   }
// `;

const ActionsWrapper = styled.div`
  display: flex;
  width: 100%;
  align-items: flex-start;
  justify-content: space-between;

  @media (max-width: 768px) {
    justify-content: flex-start;
    flex-wrap: wrap;
    gap: 12px;
  }
`;

const ActionsSide = styled.div`
  display: flex;
`;

export default class PageOnboarding extends PageSingle {
  static config = {
    ...PageSingle.config,
    ClassName: 'PageOnboarding',
  }

  renderHeaderTitle() {
    return (
      <div>
        <Logo src={logoSrc} alt="logo" />
        <div style={{ height: '30px' }} />
        <h1
          key="page-header-title"
          className="page-header-title"
        >
          {this.props.renderHeaderTitle(this.props)}
        </h1>
      </div>
    );
  }

  renderHeaderRight() {
    return (
      <WrapperHeaderRight>
        <ImageOnboarding src={onboardingSrc} />
        {/* <ImageExpress src={expressSrc} /> */}
      </WrapperHeaderRight>
    )
  }

  renderHeader() {
    return (
      <>
        <div key="page-header" className="page-header">
          <div className="page-header-left">
            {this.renderHeaderTitle()}
            {this.renderHeaderDescription()}
          </div>
          <div className="page-header-right">
            {this.renderHeaderRight()}
          </div>
        </div>
        <AntdDivider />
      </>
    );
  }

  renderBottomActions() {
    const actionsLeft = [];
    const actionsRight = [];
    this.props.actions.forEach((action) => {
      if (action.section === 'bottom') {
        if (action.right) {
          actionsRight.push(action);
        } else {
          actionsLeft.push(action);
        }
      }
    });
    return actionsLeft.length || actionsRight.length
      ? (
        <div key="actions-bottom" className="actions actions-bottom">
          <AntdDivider />
          <ActionsWrapper>
            <ActionsSide data-actions-side="left">
              {
                actionsLeft
                  .map(action => action.render(this.getStatefullProps()))
              }
            </ActionsSide>
            <ActionsSide data-actions-side="right">
              {
                actionsRight
                  .map(action => action.render(this.getStatefullProps()))
              }
            </ActionsSide>
          </ActionsWrapper>
        </div>
      )
      : null;
  }
}

Admin.addToLibrary('PageOnboarding', config => PageOnboarding.create(config));
